import { useQuery } from 'react-query'
import { config } from 'config'
import { AuthContainer } from 'containers'
import { callAxios, CustomAxiosError } from 'utils/api'

const { SECURE_BASE_URL } = config!

export type DivisionResponse = { commercial_division: string }[]

type GetDivisionRequest = {
  vendorNumber: string
  reportName?: string
}

const getDivision = async (props: GetDivisionRequest): Promise<DivisionResponse> => {
  const { vendorNumber, reportName } = props

  let queryParams = `vendornumber=${vendorNumber}`
  if (reportName) queryParams += `&reportname=${reportName}`

  const { response: divisionResponse } = await callAxios<{
    response: { data: DivisionResponse }
  }>({
    url: `${SECURE_BASE_URL}/division?${queryParams}`,
    method: 'GET',
  })

  const filteredDivisionResponse = divisionResponse.data?.filter((item) => !!item.commercial_division)

  return filteredDivisionResponse
}

export const useGetDivision = (props: Omit<GetDivisionRequest, 'vendorNumber'>) => {
  const { reportName } = props
  const { selectedSupplier } = AuthContainer.useContainer()
  const vendorNumber = selectedSupplier?.oracleId ?? ''

  const isEnabled = !!vendorNumber

  const {
    status: getDivisionStatus,
    isFetching: getIsDivisionLoading,
    data: divisionData,
    error: getDivisionError,
  } = useQuery<DivisionResponse, CustomAxiosError>(
    ['division/get', vendorNumber, reportName],
    () => getDivision({ ...props, vendorNumber }),
    { enabled: isEnabled }
  )

  return {
    getDivisionStatus,
    getIsDivisionLoading,
    divisionData,
    getDivisionError,
  }
}
